import React from 'react';
import { IconHeartOutlined, IconHeartFilled } from '@prisjakt/ui/icon';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Direction } from '@prisjakt/ui';
import { ButtonIcon, ButtonSize } from '@prisjakt/ui/button';
import { Tooltip, ButtonText, Button } from './styles';

export const SaveToListButton: React.FC<SaveToListButtonProps> = ({
  isActive,
  onClick,
}) => {
  const { t } = useAppContext();

  return (
    <Tooltip
      title={t('product', 'action-button.list-tooltip')}
      placement={Direction.Down}
      zIndex={1}
    >
      <Button
        ariaLabel={t('common', 'button.save')}
        onClick={onClick}
        size={ButtonSize.SMALL}
      >
        <ButtonIcon>
          {isActive ? <IconHeartFilled /> : <IconHeartOutlined />}
        </ButtonIcon>
        <ButtonText>{t('common', 'button.save')}</ButtonText>
      </Button>
    </Tooltip>
  );
};

interface SaveToListButtonProps {
  isActive: boolean;
  onClick?: () => void;
}
